import React, { PropTypes } from 'react';
import { Panel, Accordion } from 'react-bootstrap';
import TextInput from '../../common/TextInput';
import SelectInput from '../../common/SelectInput';
import Button from '../../common/Button';
import * as selectLists from '../../../constants/FilterSelectLists';


const EstablishmentFilterRow = ({
  enteringData,
  onSelect,
  setFilters,
  clearFilters,
  newFilterValues,
  toggleInactive
}) => {
  let filters = [
    <p className="filter-instructions" key="instructions"> To filter your list of establishments, input your criteria in one or more fields below, and then click the "Filter" button to update the list.</p>,
    <div className="row">
      <div className="col-lg-6 establishments-search-box" key="address">
        <label htmlFor="address">Establishment Name/Street/City</label>
        <TextInput
          type="text"
          placeholder="Establishment Name / Street / City"
          name="address"
          onChange={enteringData}
          value={newFilterValues.address} />
      </div>
      <div className="col-lg-6 establishments-search-box" key="status">
        <label htmlFor="submission_status">Status:</label>
        <SelectInput
          name="submission_status"
          options={selectLists.establishmentStatusForFilter}
          defaultOption="Status"
          onChange={onSelect}
          value={newFilterValues.submission_status}
        />
      </div>
    </div>,
    <div className="row">
      <div className="col-lg-6">
        <label htmlFor="establishmentId">Establishment Zip Code:</label>
        <TextInput
          type="text"
          placeholder="Zip Code"
          name="zipcode"
          onChange={enteringData}
          value={newFilterValues.zipcode}
        />
      </div>
      <div className="col-lg-6 establishments-search-box" key="state">
        <label htmlFor="state">State:</label>
        <SelectInput
          name="state"
          options={selectLists.unitedStatesForFilter}
          defaultOption="State"
          onChange={onSelect}
          value={newFilterValues.state}
        />
      </div>
    </div>,
    <div className="row">
      <div className="col-lg-6">
        <label className="checkbox-label toggle-inactive">
          <input
            type="checkbox"
            name="toggle-inactive"
            onChange={toggleInactive}
            checked={newFilterValues.establishment_status === '2'}
            className="toggle-inactive-box"
            title="Select to Include Inactive Establishments"
          />
          Include Inactive Establishments
        </label>
      </div>
    </div>,
    <br />,
    <div className="row" key="buttons">
      <div className="container">
        <Button
          value="Clear"
          disabled={false}
          onClick={clearFilters}
          className="btn-cancel"
          title="Clear Search for an Establishment Filter"
        />

        <Button
          value="Filter"
          disabled={false}
          onClick={setFilters}
          className="filter-establishment-list"
          title="Filter Establishments"
        />
      </div>
    </div>
  ];
  return (<div className="">
    <div className="filter-group col-xs-12 non-mobile">
      <div>
        <h2 className="filter-title">Search for an Establishment</h2>
      </div>
      {filters}
    </div>
    <Accordion defaultActiveKey="2">
      <Panel header={<h2 className="filter-title">Search for an Establishment</h2>}
        eventKey="1"
        className="mobile filter-group col-xs-12">
        {filters}
      </Panel>
    </Accordion>
  </div>
  );
};

EstablishmentFilterRow.propTypes = {
  enteringData: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  setFilters: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
  newFilterValues: PropTypes.object.isRequired,
  toggleInactive: PropTypes.func.isRequired


};


export default EstablishmentFilterRow;








/** WEBPACK FOOTER **
 ** ./src/components/establishment/establishmentsDashboard/EstablishmentFilterRow.js
 **/